import React from "react";
import { Box, ButtonGroup } from "@material-ui/core";
import { DetailButton } from "../../../../../../Components/DetailButton";
import { useNotify, useRefresh } from "react-admin";
import AcceptIconButton from "../../../../../../Components/AcceptButton/AcceptIconButton";
import { useAppDataProvider } from "../../../../../../dataprovider";
import RejectIconButton from "../../../../../../Components/RejectButton/RejectIconButton";
import { useAuth } from "@airborne/react-admin";
import { Roles } from "../../../../../../Enums/Roles";

export const Actions = props => {
  var dataProvider = useAppDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const { user } = useAuth();

  const handleApprove = record => {
    dataProvider
      .post("eightwings/accepted", { id: record.id })
      .then(result => {
        props?.finalCallBack?.();
        props.reloadTabs();
        notify(`Record verified`, "success", false, true);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };
  const handleReject = record => {
    dataProvider
      .post("eightwings/rejected", { id: record.id })
      .then(result => {
        props?.finalCallBack?.();
        props.reloadTabs();
        notify(`Record rejected`, "success", false, true);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };
  return (
    <Box style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "8px" }}>
      <ButtonGroup variant="text" size="small">
        <DetailButton {...props} path={"eightwings"} />
        {user?.roles?.some(x => x == Roles.EightWings) && (
          <>
            <AcceptIconButton {...props} resource={"eightwings/accepted"} onClick={handleApprove} />
            <RejectIconButton
              {...props}
              resource={"eightwings/rejected"}
              onClick={handleReject}
              title={`Reject`}
              content={"Are you sure you want to reject?"}
            />
          </>
        )}
      </ButtonGroup>
    </Box>
  );
};
export default Actions;
